import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'avn/services/api.service';
import { Constants } from 'avn/services/constants';

@Component({
  selector: 'app-for-category',
  templateUrl: './for-category.component.html',
  styleUrls: ['./for-category.component.scss']
})
export class ForCategoryComponent implements OnInit {
  subCategoryList = Constants.SUBCATEGORY_LIST;
  subCategoryDisplayList = [];
  blogContent = '';

  @Input() showSubCategories = false;
  @Input() showBlogContent = false;

  @Input() service = '';
  @Input() city = '';

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.showSubCategories ? this.generateCategoryList() : '';
    this.showBlogContent ? this.getCategoryContent() : '';
  }

  generateCategoryList() {
    this.subCategoryDisplayList = this.subCategoryList[this.service] || [];
  }

  getCategoryContent() {
    let page = '';
    if (this.city) {
      page = `${this.service}-${this.city}`;
    } else {
      page = `service-${this.service}`;
    }
    this.api.getCategoryContent(page).subscribe((response) => {
      this.blogContent = response[0]?.content?.rendered;
    });
  }
}
